import { Typography, Row, Col }  from 'antd'
import { useState } from "react";
import Breakpoint from "../../enums/breakpoint.enum";
import { TassoPopover } from '../tassoPopover/tassoPopover.component';
import useWidth from '../../hooks/useWidth.hook';

const { Text, Paragraph } = Typography

const CholesterolBalanceIntro = ({ footer, productType }) => {
  const width = useWidth()

  const instructions = [{
    sections: [
      {
      title: 'Receive Collection Kit',
      description: <>Our lab partner, Boston Heart Diagnostics, will ship your blood collection kit via FedEx. It should arrive within one week of purchase.</>
    },   
  ]}, 
  {
    sections: [{
      title: 'Get Blood Drawn',
      description: <>You can schedule a phlebotomist to come to your home or office for a standard blood draw. And coming soon you can self collect your blood using finger prick or Tasso+ device.</>
    }]
  }, 

  // {
  //   sections: [{
  //     title: 'Get Blood Drawn',
  //     description: <>You can use the painless <TassoPopover trigger={<a className="tasso-popover-link">Tasso+ device</a>}/> to collect your blood yourself, or schedule a phlebotomist to come to your home or office to visit your home or office for a standard blood draw.</>
  //   }]
  // }, 
  {
    sections: [{
      title: 'View Test Results Online',
      description: <>Once your sample reaches the lab, your test results will be ready in about one week. We’ll email you as soon as they’re available.</>
    }]
  }]
  return (
    <div 
      className="flow-intro"
      style={{
        minHeight: width >= Breakpoint.XL ? 'calc(100vh - 86px)' : 'calc(100vh - 60px)',
      }}
    >


      <div 
        className="flow-intro-body"
        style={{
          minHeight: width >= Breakpoint.XL ? 'calc(100vh - 86px)' : 'calc(100vh - 60px)',
        }}
      >
        <Paragraph 
          className="flow-title"
          style={{
            fontSize: width > Breakpoint.SM ? 32 : 28,
          }}
        >
          {productType.title} - ${productType.cost}
        </Paragraph>
        <Paragraph 
          className="flow-description"
          style={{
            fontSize: width > Breakpoint.SM ? 16 : 14,
          }}
        >
          {productType.tagline}
        </Paragraph>

        <div 
          className="instruction-list"
          style={{
            marginTop: width > Breakpoint.SM ? 50 : 30,
            marginBottom: width > Breakpoint.SM ? -15 : -25,
            paddingTop: width > Breakpoint.SM ? 25 : 15,
          }}
        >
          {instructions.map(({ sections }, instructionIndex) => (
            <div 
              key={`instruction-${instructionIndex}`} 
              className="instruction-item"
            >
              <Row>
                <Col
                  style={{
                    width: width > Breakpoint.SM ? 80 : '100%',
                    marginBottom: width > Breakpoint.SM ? 0 : 10
                  }}
                >
                  <Text className="instruction-index">
                    Step {instructionIndex+1}
                  </Text>
                </Col>

                <Col
                  style={{
                    width: width > Breakpoint.SM ? 'calc(100% - 80px)' : '100%'
                  }}
                >
                  {sections.map(({ title, description }, sectionIndex) => (
                    <div 
                      key={`section-${instructionIndex}-${sectionIndex}`} 
                      className="section-item"
                    >
                      <Text className="section-title">
                        {title}
                      </Text>
                      <Paragraph className="section-description">
                        {description}
                      </Paragraph>
                    </div>
                  ))}
                  </Col>
              </Row>
            </div>
          ))}
        </div>

        <div className="flow-intro-btn-container">
          <div className="flow-intro-btn">
            {footer({ 
              buttonText: "Let's go",
              buttonCheck: false,
              buttonStyle: {
                height: 50,
                fontSize: 18,
                width: '100%',
                display: 'block',
              },
              enterStyle: {
                display: 'none',
              }
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CholesterolBalanceIntro